import styled from "@emotion/styled";
import { Ui } from "@silvertours/front-shared";
var List = /*#__PURE__*/ styled("ul", {
    target: "e69h6860"
})("padding:0 ", function(param) {
    var theme = param.theme;
    return theme.spacing[50];
}, ";width:100%;", function(param) {
    var theme = param.theme;
    return theme.mq("lg");
}, "{width:238px;}*{font-family:", function(param) {
    var theme = param.theme;
    return theme.fontFamily.alternate;
}, ";}");
var NavigationItem = /*#__PURE__*/ styled("li", {
    target: "e69h6861"
})("padding:", function(param) {
    var theme = param.theme;
    return theme.spacing[40];
}, " 0;color:", function(param) {
    var theme = param.theme;
    return theme.color.natural100;
}, ";text-overflow:ellipsis;overflow-x:hidden;", function(param) {
    var theme = param.theme;
    return theme.mq("lg");
}, "{display:block;}");
var StyledLink = /*#__PURE__*/ styled(Ui.TextLink, {
    target: "e69h6862"
})(function(param) {
    var theme = param.theme;
    return theme.mq("lg");
}, "{display:block;}");
export { List, NavigationItem, StyledLink };
